var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgendaCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#264F3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0136 4C8.01746 4 6 6.3985 6 9.93856V18H9.21075V14.3802H14.8809V18H18.098V9.93856C18.098 6.50873 15.9123 4 12.0136 4ZM9.21075 9.86929C9.16547 9.48749 9.20628 9.1004 9.33018 8.73643C9.45408 8.37246 9.65792 8.04087 9.92674 7.76599C10.1956 7.49112 10.5225 7.27994 10.8836 7.14796C11.2448 7.01598 11.6309 6.96656 12.0136 7.00333C12.3987 6.96843 12.7869 7.0186 13.1505 7.15027C13.5141 7.28194 13.8444 7.4919 14.1179 7.7653C14.3915 8.0387 14.6016 8.36886 14.7334 8.73244C14.8653 9.09601 14.9156 9.48411 14.8809 9.86929V11.3755H9.21075V9.86929Z",
    fill: "#CF112D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendaCircle);
export default __webpack_public_path__ + "static/media/agenda-circle.7f81ee61.svg";
export { ForwardRef as ReactComponent };